var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: "fadeIn",
          expression: "'fadeIn'",
        },
      ],
      staticClass:
        "d-flex flex-column align-items-center justify-content-center p-3",
      class: _vm.containerClass,
    },
    [
      _vm.icon
        ? _c("b-img", {
            staticClass: "mb-3",
            attrs: {
              src: _vm.icon,
              alt: _vm.message || _vm.$t("shared.nothingFound"),
              width: _vm.iconWidth,
              height: _vm.iconHeight,
            },
          })
        : _vm._e(),
      !_vm.noMessage
        ? _c(
            _vm.messageTag,
            {
              tag: "component",
              class: ["text-muted text-center", _vm.messageClass],
            },
            [
              _vm._v(
                " " + _vm._s(_vm.message || _vm.$t("shared.nothingFound")) + " "
              ),
            ]
          )
        : _vm._e(),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }